import { DeviceContext } from "libs/contexts"
import { useContext, useEffect, useState } from "react"

export function useBannerImage() {
  const [renderBannerImg, setRenderBannerImg] = useState(false)
  const { supportsWebp } = useContext(DeviceContext)

  useEffect(() => {
    setRenderBannerImg(true)
  }, [])

  function handleErrorImg(err) {
    const src = err.target.src
    if (src.endsWith(".webp")) {
      err.target.src = src.slice(0, src.length - 5)
    }
  }

  function buildBannerImgSrc(src) {
    return supportsWebp ? `${src}.webp` : src
  }

  return {
    renderBannerImg,
    handleErrorImg,
    buildBannerImgSrc,
  }
}
